import { render } from "./ServiceDistribution.vue?vue&type=template&id=fba348ae&scoped=true&ts=true"
import script from "./ServiceDistribution.vue?vue&type=script&lang=ts"
export * from "./ServiceDistribution.vue?vue&type=script&lang=ts"

import "./ServiceDistribution.vue?vue&type=style&index=0&id=fba348ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba348ae"]])

export default __exports__